import { render, staticRenderFns } from "./gainCountCate.vue?vue&type=template&id=cdfca972&scoped=true"
import script from "./gainCountCate.vue?vue&type=script&lang=js"
export * from "./gainCountCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfca972",
  null
  
)

export default component.exports